import Http from 'common/services/Http';

export interface ExpressionParameter {
    id: string;
    name: string;
    value: number | number[] | null;
}

export interface ExpressionResult {
    value: number;
    error: boolean;
    errorMessage?: string;
}

export interface EvaluateExpressionRequest {
    expression: string;
    parameters: ExpressionParameter[];
}

// Backend expects separate Value and Values properties
interface BackendExpressionParameterRequest {
    id: string;
    name: string;
    value: number | null;
    values: number[] | null;
}

interface BackendEvaluateExpressionRequest {
    expression: string;
    parameters: BackendExpressionParameterRequest[];
}

class ExpressionsService {
    public evaluate(request: EvaluateExpressionRequest) {
        // Transform to backend format
        const backendRequest: BackendEvaluateExpressionRequest = {
            expression: request.expression,
            parameters: request.parameters.map(p => ({
                id: p.id,
                name: p.name,
                value: Array.isArray(p.value) ? null : p.value,
                values: Array.isArray(p.value) ? p.value : null
            }))
        };
        return Http.post<ExpressionResult>('expressions/evaluate', backendRequest);
    }
}

export default new ExpressionsService();
